/* eslint-disable no-console */
import React from 'react';

import { mdiFileArrowUpDown } from '@mdi/js';
import Icon from '@mdi/react';

import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Typography, Paper, Link, Box } from '@mui/material';

// import Accordion from '@mui/material/Accordion';
// import AccordionDetails from '@mui/material/AccordionDetails';
// import AccordionSummary from '@mui/material/AccordionSummary';

import { Alert, Button } from 'daaas-ui';

import BrandingDAS from '../components/Layout/BrandingDAS';
import VmSectionVdl from '../components/UI/VmSectionVdl';

import hubHeaderBlack from '../assets/images/hubHeaderBlack.svg';

import ContentContainer from '../components/Layout/ContentContainer';

const Root = styled('div')(({ theme }) => ({
  '.MuiChip-outlinedPrimary': {
    marginTop: theme.spacing(1),
    border: '3px solid',
    borderColor: `${theme.palette.primary.main} !important`,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderTopLeftRadius: theme.spacing(0.625),
    borderTopRightRadius: theme.spacing(0.625),
    borderBottomLeftRadius: theme.spacing(0.625),
    borderBottomRightRadius: theme.spacing(0.625),
    '& .MuiChip-label': {
      fontWeight: 'bolder',
      fontSize: '1rem',
    },
  },
  '.imgSizing': {
    width: '1.5rem',
    height: '1.5rem',
  },
  '.MuiTypography-root.MuiTypography-body1': {
    fontSize: 'inherit',
  },
  '.opensWindowMargin': {
    marginLeft: theme.spacing(1),
    verticalAlign: 'text-bottom',
  },
  '.hub-page__header': {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(0),
    marginTop: theme.spacing(4),
    paddingLeft: theme.spacing(2),
    backgroundImage: `url(${hubHeaderBlack})`,
    backgroundColor: '#f7931e',
    backgroundPosition: 'right top',
    backgroundSize: '40%',
    borderTopLeftRadius: theme.spacing(1.25),
    borderTopRightRadius: theme.spacing(1.25),
    backgroundRepeat: 'no-repeat',
    [theme.breakpoints.up('sm')]: {
      backgroundPosition: 'right top -10px',
      backgroundSize: '40%',
    },
    [theme.breakpoints.up('md')]: {
      backgroundPosition: 'right top -15px',
      backgroundSize: '30%',
    },
    [theme.breakpoints.up('lg')]: {
      backgroundPosition: 'right top -15px',
      backgroundSize: '25%',
    },
  },

  '.MuiPaper-root.MuiAccordion-root .MuiButtonBase-root.MuiAccordionSummary-root>.MuiAccordionSummary-expandIconWrapper':
    {
      margin: theme.spacing(2),
    },
  '& .hub_paper': {
    backgroundColor: '#F8F8F8',
    marginTop: theme.spacing(0),
    paddingTop: theme.spacing(0),
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    paddingBottom: theme.spacing(3),
    marginBottom: theme.spacing(6),
    textAlign: 'left',
    height: '100%',
    borderTopRightRadius: theme.spacing(0),
    borderTopLeftRadius: theme.spacing(0),
    boxSizing: 'border-box',
    '&:last-of-type': {
      marginBottom: theme.spacing(0),
    },
  },
  '.MuiPaper-root.MuiAccordion-root.Mui-expanded, .MuiPaper-root.MuiAccordion-root, .MuiPaper-root.MuiAccordion-root .MuiButtonBase-root.MuiAccordionSummary-root:hover ':
    {
      borderTopLeftRadius: theme.spacing(1.25),
      borderTopRightRadius: theme.spacing(1.25),
      borderBottomLeftRadius: theme.spacing(1.25),
      borderBottomRightRadius: theme.spacing(1.25),
      boxShadow: '0px 0px 6px #00000029',
    },

  '& .hub-page__list': {
    paddingLeft: theme.spacing(3),
    '&>li': {
      marginBottom: theme.spacing(0.5),
    },
  },
  '& .hub-page__list__no__bullets': {
    paddingLeft: theme.spacing(0),
    '&>li': {
      display: 'flex',
      alignItems: 'flex-start',
      marginBottom: theme.spacing(1),
      listStyleType: 'none',
      '&>.MuiIconButton-root': {
        marginTop: theme.spacing(-1),
      },
    },
  },
  '& .hub-page__nestedList': {
    paddingLeft: theme.spacing(0),
    '&>li': {
      display: 'flex',
      alignItems: 'flex-start',
      listStyleType: 'none',
      '&>.MuiIconButton-root': {
        marginTop: theme.spacing(-1),
      },
      '&>ul': {
        paddingLeft: theme.spacing(6),
        listStyleType: 'disc',
      },
    },
  },
  '& .hub-page__gaeAccordion': {
    display: 'inline-flex',
    alignItems: 'flex-start',
    marginTop: theme.spacing(-2),
    marginLeft: theme.spacing(3),
    padding: theme.spacing(0.5, 1),
    '& .MuiListItemText-root': {
      flexGrow: 0,
    },
    '& svg': {
      marginLeft: theme.spacing(1),
    },
  },
  '& .hub-page__gaeCollapse': {
    '& ul': {
      marginTop: theme.spacing(1),
      paddingLeft: theme.spacing(6),
      '&>li': {
        '&>.MuiIconButton-root': {
          marginTop: theme.spacing(-1),
        },
      },
    },
  },
  '& .bgWhite': {
    backgroundColor: theme.palette.common.white,
  },
}));

export default function HubVdl() {
  const { t, i18n } = useTranslation(['common', 'hubvdl']);

  React.useEffect(() => {
    setTimeout(() => {
      document.title = `${t('common:daaas')} - ${t('common:vdlHub')}`;
      // This is an authenticated page and won't be crawled, but settings the metadata anyways.
      document
        .querySelector("meta[name='description']")
        .setAttribute('content', t('hubvdl:description'));
      document
        .querySelector("meta[name='keywords']")
        .setAttribute('content', t('hubvdl:keywords'));
      document
        .querySelector("link[rel='canonical']")
        .setAttribute('href', t('hubvdl:canonical'));
      document
        .querySelector("meta[name='dcterms.title']")
        .setAttribute('content', t('hubvdl:dctermsTitle'));
      document
        .querySelector("meta[name='dcterms.description']")
        .setAttribute('content', t('hubvdl:dctermsDescription'));
      document
        .querySelector("meta[name='dcterms.creator']")
        .setAttribute('content', t('common:dctermsCreator'));
      document
        .querySelector("meta[name='dcterms.language']")
        .setAttribute('content', t('common:dctermsLanguage'));
      document
        .querySelector("meta[name='dcterms.subject']")
        .setAttribute('content', t('common:dctermsSubject'));
    }, '100');
  }, [i18n.language]);

  // React.useEffect(() => {
  //   // TODO: add code here to ensure token is not expired, else get refresh token?
  //   // Once token is not expired then allow execution to continue?
  // }, []);

  return (
    <Root>
      <ContentContainer paddingBottom={false}>
        <Alert
          open
          severity="warning"
          closeable={false}
          sx={{
            mt: 4,
          }}
        >
          {t('hubvdl:securityBanner')}
        </Alert>
        <Box className="hub-page__header">
          <Typography
            variant="h3"
            component="h1"
            sx={(theme) => ({
              color: theme.palette.common.black,
            })}
          >
            {t('common:vdlHub')}
          </Typography>
        </Box>
        <Paper className="hub_paper das-paper" variant="outlined">
          <Typography variant="body1" sx={{ px: 2, my: 2 }}>
            {t('hubvdl:inTheVdlEnvironment')}
          </Typography>
          <Button
            sx={{ ml: 2, my: 1 }}
            className="bgWhite"
            variant="outlined"
            color="primary"
            href={`${t('hubvdl:documentationHref')}`}
            target="_blank"
          >
            {t('hubvdl:documentation')}
          </Button>
          <Button
            sx={{ ml: 2, my: 1 }}
            className="bgWhite"
            variant="outlined"
            color="primary"
            startIcon={<Icon path={mdiFileArrowUpDown} size={1} />}
            // TODO: Change the "/upload" URL below to the "/transferFiles" URL when that page is created
            href={`${t('hubvdl:transferFilesHref')}`}
            target="_blank"
          >
            {t('hubvdl:transferFiles')}
          </Button>
          <Alert
            open
            severity="info"
            closeable={false}
            sx={{
              my: 2,
              mx: 2,
            }}
          >
            {t('hubvdl:forQuestionsRelatedTo')}
            <ul>
              <li>
                <Typography component="span" sx={{ fontWeight: 'bold' }}>
                  {t('hubvdl:confidentialityVettingAndDataPt1')}
                </Typography>
                <Typography component="span">
                  {t('hubvdl:confidentialityVettingAndDataPt2')}
                </Typography>
                <Link
                  underline="always"
                  href={t('hubvdl:dadFrdcVettingMailTo')}
                  target="_blank"
                >
                  {t('hubvdl:confidentialityVettingAndDataPt3')}
                </Link>
              </li>
              <li>
                <Typography component="span" sx={{ fontWeight: 'bold' }}>
                  {t('hubvdl:forAllOtherInquiriesPt1')}
                </Typography>
                <Typography component="span">
                  {t('hubvdl:forAllOtherInquiriesPt2')}
                </Typography>
                <Link
                  underline="always"
                  href={t('hubvdl:dadFrdcAdminMailTo')}
                  target="_blank"
                >
                  {t('hubvdl:forAllOtherInquiriesPt3')}
                </Link>
                <Typography component="span">
                  {t('hubvdl:forAllOtherInquiriesPt4')}
                </Typography>
              </li>
            </ul>
          </Alert>
          <VmSectionVdl />
          {/*
          <Typography
            component="h2"
            variant="h3"
            sx={{
              ml: 1,
              mt: 6,
              mb: 3,
            }}
          >
            {t('common:faq')}
          </Typography>
          <Divider sx={{ mb: 3 }} />
          <Box>
            <Accordion>
              <AccordionSummary
                expandIcon={<Icon path={mdiChevronDown} size={1} />}
                aria-controls="vdl-vms-content"
                id="vdl-vms-header"
                sx={{ mt: 2 }}
              >
                <Typography
                  component="h3"
                  variant="body1"
                  className="vmSection__tableHeading"
                >
                  {t('hubvdl:faq1Question')}
                </Typography>
              </AccordionSummary>
              <Divider sx={{ mx: 2 }} />
              <AccordionDetails>
                <Typography variant="body1" sx={{ px: 2, my: 2 }}>
                  {t('hubvdl:faq1Answer')}
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<Icon path={mdiChevronDown} size={1} />}
                aria-controls="vdl-vms-content"
                id="vdl-vms-header"
                sx={{ mt: 2 }}
              >
                <Typography
                  component="h3"
                  variant="body1"
                  className="vmSection__tableHeading"
                >
                  {t('hubvdl:faq2Question')}
                </Typography>
              </AccordionSummary>
              <Divider sx={{ mx: 2 }} />
              <AccordionDetails>
                <Typography variant="body1" sx={{ px: 2, my: 2 }}>
                  {t('hubvdl:faq2Answer')}
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary
                expandIcon={<Icon path={mdiChevronDown} size={1} />}
                aria-controls="vdl-vms-content"
                id="vdl-vms-header"
                sx={{ mt: 2 }}
              >
                <Typography
                  component="h3"
                  variant="body1"
                  className="vmSection__tableHeading"
                >
                  {t('hubvdl:faq3Question')}
                </Typography>
              </AccordionSummary>
              <Divider sx={{ mx: 2 }} />
              <AccordionDetails>
                <Typography variant="body1" sx={{ px: 2, my: 2 }}>
                  {t('hubvdl:faq3Answer')}
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Box>
          */}
        </Paper>
      </ContentContainer>
      <BrandingDAS />
    </Root>
  );
}
